var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"push-bottom-xl"},[_c('Label',{attrs:{"label":_vm.$t('hunt.summary.inviteTitle')}}),_c('div',{staticClass:"note",domProps:{"innerHTML":_vm._s(_vm.hunt.note)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }